module.exports = __webpack_public_path__ + "img/logoText.95015cc9.png";